<template>
    <!-- <v-container class='containerPage'> -->
    <container-page :headerHeight="'25%'" :bodyHeight="'89%'" class="header-customized">
        <template v-slot:header>
            <div class="headerItemsResponsive">
                <span class="titlePage"> {{'Atendimentos' | translate('Atendimentos')}} </span>
                <div class="headerbuttons space-top">
                    <v-spacer></v-spacer>
                    <v-btn
                        class="btn1 marginRight" 
                        dark
                        small
                        to="/atendimento?callType=customer"
                    >
                        <v-icon small>
                            mdi-plus
                        </v-icon>
                        <span>{{ 'Novo Atendimento' | translate('Atendimentos') }}</span>
                    </v-btn>             
                </div>
            </div>
            <v-tabs
                id="tabsElement"
                height="60px"
                class="headerTabs"
                color="black"
                slider-size="4" 
                v-if="!loading && situations.length" 
                v-model="tab"
                show-arrows
                v-resize="onResize"
            >
                <v-tab class="atendimentosTab" v-for="(situation, i) in situations" 
                    :key="i" 
                    :id="getSituationElementId(situation)"
                    @click="changeRouter(situation)"
                >
                    <div class=tabStyle>
                        <div class="tab">
                            <div class="badge" v-if="situation.noViews">
                                <span>{{situation.noViews}}</span>
                            </div>
                            <span class="tabFont">{{situation.NOME | translate('Atendimentos')}}</span>
                        </div>
                        <span class="tabFont">{{situation.QTD}}</span>
                    </div>
                </v-tab>
            </v-tabs>
            <div id="borderBottomTabs" class="borderBottomTabs"></div>
        </template>
        <template v-slot:body>
            <div v-if="loading" class="pageLoader">
                <v-progress-circular indeterminate size="40" width="4" color="black"></v-progress-circular>
                <span class="pageLoaderText">{{ 'Carregando informações' | translate('Atendimentos') }}</span>
            </div>
            <div class="divTabs">
                <v-tabs-items v-model="tab" style="height:100%;">
                    <v-tab-item v-for="(situation, i) in situations" :key="i" style="height:100%;">
                    </v-tab-item>
                </v-tabs-items>
                <router-view v-if="!loading && situations.length" />
            </div>
        </template>
    </container-page>
</template>

<script>
import translate from '../../../src/plugins/translate'
import getAllCallSituations from '../../../src/app/situacaoAtendimento/getAllCallSituationsQuantities'
import ContainerPage from '../../../src/components/containerPage.vue'
import { createNamespacedHelpers } from 'vuex'
import { eventBus } from '../../../src/plugins/bus' 
import { doesEventExist } from '../../../src/app/util/index'

const user = createNamespacedHelpers('user')

export default {
    name: 'Atendimentos',
    components: {ContainerPage},
    data() {
        return {
            tab: this.$route.params.tab ? Number(this.$route.params.tab) : null,
            loading: true,
            search: null,
            situations: [],
            labels: {
                textLoading: translate('Carregando atendimentos', 'Atendimentos'),
                textNoData: translate('Nenhum registro localizado', 'Atendimentos')
            },
            imageTime: new Date().getTime()
        }
    },
    computed:{
        ...user.mapGetters(['user'])
    },
    methods: {
        onResize () {
            this.windowSize = { x: window.innerWidth, y: window.innerHeight }
            this.setWidthBordersTabs()
        },
        async getAllSituations() {
            this.loading = true
            var binds = {companyId:this.user.EMPRESA_ID, active:'S', userId:this.user.USUARIO_ID, clientId: this.user.CLIENTE_ID, factoryUserId:this.user.EMPRESA_USUARIO_ID, hidesUnlinkedCall: this.user.OCULTAR_ATEND_NAO_VINCULADO, userRoleDescription: this.user.FUNCAO_USUARIO_DESCRICAO}
            if(this.user.ADM == 'S'){
                binds.isAdmin = true
            }
            try {
                const response = await getAllCallSituations(binds)
                this.situations = response.data
                this.setWidthBordersTabs()
            } finally {
                this.loading = false
            }
        },
        setWidthBordersTabs(){
            setTimeout(function(){
                var divTabs = document.getElementById('tabsElement')
                var tabsBorder = document.getElementById('borderBottomTabs')
                var allTabs = document.getElementsByClassName('atendimentosTab')
                if(divTabs && tabsBorder.offsetWidth < divTabs.offsetWidth) {
                    var widthBorderBoddom = 0
                    allTabs.forEach(function(tab){
                        widthBorderBoddom += tab.offsetWidth
                    })
                    let element = document.getElementById('borderBottomTabs')
                    element.style.width = `${widthBorderBoddom}px`
                } else tabsBorder.style.width = divTabs ?`${divTabs.offsetWidth}px` : tabsBorder.style.width
            },600)
        },
        changeRouter(situation){
            const situationElementId = this.getSituationElementId(situation)
            const isAnotherRoute = window.location.hash != `#${situationElementId}`

            if(isAnotherRoute) this.$router.push(situationElementId)

            this.reloadAtendimentos()
        },
        getTranslate(term, screen){
            return translate(term, screen)
        },
        getSituationElementId(situation){
            return '/atendimentos/'+situation.ID+'/'+this.getTabBySituation(situation)
        },
        getTabBySituation(situation){
            return this.situations.findIndex(s => s.ID == situation.ID)
        },
        getRouteParams(){
            return {
                id: this.$route.params.id ? JSON.parse(this.$route.params.id) : null,
                tab: this.$route.params.tab ? JSON.parse(this.$route.params.tab) : null
            }
        },
        reloadAtendimentos(){
            const eventName = 'reloadAtendimentosTable'
            if(doesEventExist(eventName, eventBus)) return eventBus.$emit(eventName)
            else return setTimeout(this.reloadAtendimentos.bind(this), 100)
        }
    },
    async created(){
        this.$nextTick(async function() {
            await this.getAllSituations()
            setTimeout(function(){
                const isFirstTime = window.location.hash == '#/atendimentos'

                const situation = isFirstTime
                    ? this.situations[0]
                    : { ID: this.getRouteParams().id }

                this.changeRouter(situation)
            }.bind(this),120)
        }.bind(this))
        this.onResize()
    }
}
</script>
<style scoped>
.pageLoader{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    min-height: 50vh;
}
.pageLoaderText{
    margin-top: 16px;
    font-size: 14px;
}
.container-page-body-space >>> body{
    margin-top: 5rem;
}
.space-top{
    margin-top: 5rem;
}
.btn1{
    text-transform: none !important;
}
.titlePage{
    font-size: 20px;
    font-weight: 700;
}
.headerbuttons{
    /* padding-bottom: 2em; */
    position: relative;
    /* top: 22px; */
    margin-right: 4em;
    margin-top: 4em;
    display: flex;
}
.marginRight{
    margin-right: 1em;
}
.assuntoColumn{
    max-width: 200px;
}
/* .divTabs{
    height: 100%;
} */
.headerTabs{
    /* margin-bottom: 2%; */
    margin-right: 8px;
    margin-left: 8px;
    width: 89%;
    position: relative;
    /* top: 25px; */
}
.borderBottomTabs{
    border-bottom: 4px solid #80808052;
    position: relative;
    bottom: 0.3em;
    width: 1px;
    z-index: 1;
    border-radius: 50px;
    margin-right: 8px;
    margin-left: 8px;
}
.tabStyle{
    font-weight: bolder;
    display: grid;
    position: relative;
    top: 4px;
}
.tab{
    display: flex;
    position: relative;
}
.tabFont{
    font-size:13px; 
    font-weight: bolder;
}
.badge{
    position: absolute;
    right: -14px;
    top: -8px;
    background-color: #d93025;
    width: min-content;
    height: 14px;
    border-radius: 50px;
    min-width: 14px;
    display: flex;
    align-items: center;
    justify-content: center;
}
.badge > span{
    font-size: 10px;
    position: relative;
    left: .8px;
    color: white;
    padding: 2px;
}
.v-tabs-slider-wrapper{
    height: 5px;
}

.header-customized >>> .header{
    max-height: none !important;
}

.headerItemsResponsive{
    margin-bottom: 1em;
}

@media only screen and (max-width: 539px){
    .btn1{
        display: none;
    }
    .assuntoColumn{
        max-width: 40px;
    }
    .headerItemsResponsive{
        display: flex;
    }
}
@media only screen and (min-width: 540px) and (max-width: 739px){
    .assuntoColumn{
        max-width: 100px;
    }
    .headerItemsResponsive{
        display: flex;
    }
    .titlePage{
        margin-right: 2em;
    }
}
@media only screen and (min-width: 601px) and (max-width: 820px){
    .assuntoColumn{
        max-width: 160px;
    }
    .headerItemsResponsive{
        display: flex;
    }
    .titlePage{
        margin-right: 2em;
    }
}
@media only screen and (min-width: 821px) and (max-width: 1380px){
    /* .headerbuttons{
        top: 32px !important;
    } */
    /* .headerTabs{
        top: 30px !important;
    } */
    /* .borderBottomTabs{
        top: 90px !important;
    } */
}
@media only screen and (min-height: 780px) and (max-height: 850px){
    .container-page-body-space >>> body{
        margin-top: 4rem;
    }
}
@media only screen and (min-height: 851px) and (max-height: 921px){
    .container-page-body-space >>> body{
        margin-top: 3rem;
    }
}
@media only screen and (min-height: 922px) and (max-height: 992px){
    .container-page-body-space >>> body{
        margin-top: 2rem;
    }
}
</style>
